import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-977cd4d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-flex"} }, "订舱信息", -1))
const _hoisted_2 = { class: "form-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_summary_time = _resolveComponent("order-summary-time")!
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_order_detail_company_business_card = _resolveComponent("order-detail-company-business-card")!
  const _component_order_detail_products_summary = _resolveComponent("order-detail-products-summary")!
  const _component_order_detail_container = _resolveComponent("order-detail-container")!
  const _component_order_detail_cost = _resolveComponent("order-detail-cost")!
  const _component_order_detail_lading_bill = _resolveComponent("order-detail-lading-bill")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_order_main_bill_detail = _resolveComponent("order-main-bill-detail")!
  const _component_order_part_bill_detail = _resolveComponent("order-part-bill-detail")!
  const _component_order_manifest_vgm_detail = _resolveComponent("order-manifest-vgm-detail")!
  const _component_miezz_common_history = _resolveComponent("miezz-common-history")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, {
      center: _withCtx(() => [
        _createVNode(_component_order_summary_time, { id: _ctx.id }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_card, {
      toggle: true,
      down: true,
      topButtons: _ctx.topButtons,
      onHandleHeaderButtonClick: _ctx.handleHeaderButtonClick
    }, {
      headerLeft: _withCtx(() => [
        _hoisted_1,
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              style: {"display":"inline-flex","margin":"0px","font-size":"14px"},
              label: _ctx.form.Data.HasPartBill ? '有分单信息' : '无分单信息',
              "label-width": "141px"
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _ctx.form.Data,
              ref: "ruleForm",
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_order_detail_company_business_card, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "业务类型" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.type), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "订舱代理" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.logier?.DisabledReadSupplier
                  ? _ctx.logier.ServiceProviderCompanyNameZh +
                    (_ctx.logier.ServiceProviderCompanyNameEn
                      ? `/${_ctx.logier.ServiceProviderCompanyNameEn}`
                      : "")
                  : _ctx.form.Data.SupplierCompanyLabel &&
                    _ctx.form.Data.SupplierCompanyContactLabel
                  ? `${_ctx.form.Data.SupplierCompanyLabel ?? "暂无数据"}/${
                      _ctx.form.Data.SupplierCompanyContactLabel ?? "暂无数据"
                    }`
                  : _ctx.form.Data.SupplierCompanyLabel
                  ? _ctx.form.Data.SupplierCompanyLabel
                  : "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of  Loading/装货港",
                        prop: "LoadingPortId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.LoadingPortLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Discharge/卸货港",
                        prop: "DischargePortId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.DischargePortLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Delivery/目的港",
                        prop: "DeliveryPortId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPortLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Place of Delivery/交货地点",
                        prop: "DeliveryPlaceLabel"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPlaceLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "详细地址",
                        prop: "DeliveryPlaceAddress"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPlaceAddress ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "承运人",
                        prop: "CarrierId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.CarrierLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "渠道",
                        prop: "TransportChannelId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.TransportChannelLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "合约号",
                        prop: "ContractNo"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.ContractNo ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "船名",
                            prop: "ShipName"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.ShipName ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "航次",
                            prop: "VoyageNumber"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.VoyageNumber ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Air)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "航班",
                            prop: "Flight"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.Flight ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Railway)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: "班次",
                            prop: "RailwayNumber"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.RailwayNumber ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "装货港ETD",
                        prop: "EstimatedDepartureDate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedDepartureDate)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "目的港ETA",
                        prop: "EstimatedArrivalDate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedArrivalDate)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运费支付方式",
                        prop: "TransportPaymentType"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.transportPaymentType), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运输类型",
                        prop: "GoodsTransportType"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.goodsTransportType), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "备注",
                        prop: "Remark"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.Remark ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["form"]),
                  _createVNode(_component_order_detail_products_summary, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form) = $event))
                  }, null, 8, ["form"]),
                  (
            _ctx.form.Data.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          )
                    ? (_openBlock(), _createBlock(_component_order_detail_container, {
                        key: 0,
                        form: _ctx.form,
                        "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form) = $event))
                      }, null, 8, ["form"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_order_detail_cost, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form) = $event))
                  }, null, 8, ["form"]),
                  _createVNode(_component_order_detail_lading_bill, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form) = $event))
                  }, null, 8, ["form"])
                ])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["topButtons", "onHandleHeaderButtonClick"]),
    _createVNode(_component_order_main_bill_detail),
    (_ctx.form.Data?.HasPartBill)
      ? (_openBlock(), _createBlock(_component_order_part_bill_detail, { key: 0 }))
      : _createCommentVNode("", true),
    (
      _ctx.form.Data?.TransportDirection == _ctx.EnumTransportDirection.Export &&
      _ctx.form.Data?.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
    )
      ? (_openBlock(), _createBlock(_component_order_manifest_vgm_detail, {
          key: 1,
          id: _ctx.id
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    (_ctx.logier?.CompanyType != _ctx.EnumCompanyType.Customer)
      ? (_openBlock(), _createBlock(_component_miezz_common_history, {
          key: 2,
          modelValue: _ctx.histories,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.histories) = $event)),
          "label-width": "190px"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.buttons,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.buttons) = $event)),
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"])
  ], 64))
}